import { validate } from './form'

export const validateAllFieldsOld = (formValues) => {
  let hasError = false

  Object.keys(formValues).forEach((fieldName) => {
    const validation = form.validateField(fieldName)

    if (validation.hasError) {
      form.setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: validation?.error ? validation.error : null,
      }))
    }
    hasError = hasError || validation.hasError
  })
  return hasError
}

export const otherValidateFunction = (form, fieldName, index = null) => {
  const value = index ? `${fieldName}.${index}` : fieldName

  const validation = form.validateField(value)
  // if (validation.hasError) {

  //   form.setErrors((prevErrors) => ({
  //     ...prevErrors,
  //     [value]: validation?.error ? validation.error : null,
  //   }))

  // }
  return validation.hasError
}

/**
 * The field paths a step submits, enumerated the way its Continue validates
 * them: one path per array element sub-field, per object sub-field, or per
 * scalar. Validation always reads the form's own values; the payload only
 * decides which paths are checked.
 */
export const collectFieldPaths = (formValues): string[] => {
  const paths: string[] = []
  Object.keys(formValues ?? {}).forEach((fieldName) => {
    const value = formValues[fieldName]
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (item && typeof item === 'object') {
          Object.keys(item).forEach((subFieldName) =>
            paths.push(`${fieldName}.${index}.${subFieldName}`)
          )
        } else {
          paths.push(`${fieldName}.${index}`)
        }
      })
    } else if (
      value &&
      typeof value === 'object' &&
      Object.keys(value).length
    ) {
      Object.keys(value).forEach((subFieldName) =>
        paths.push(`${fieldName}.${subFieldName}`)
      )
    } else {
      paths.push(fieldName)
    }
  })
  return paths
}

export const validateAllFields = (form, formValues) =>
  collectFieldPaths(formValues).reduce(
    (hasError, path) => otherValidateFunction(form, path) || hasError,
    false
  )

/**
 * The errors a step's Continue would raise, without touching the form. Same
 * resolver, same values, same path matching as Mantine's validateField.
 */
export const findStepErrors = (values, payload): Record<string, string> => {
  const errors = validate(values) ?? {}
  const errorKeys = Object.keys(errors)
  const found: Record<string, string> = {}
  collectFieldPaths(payload).forEach((path) => {
    const parts = path.split('.')
    const match = errorKeys.find((errorKey) =>
      parts.every((part, i) => part === errorKey.split('.')[i])
    )
    if (match) found[path] = String(errors[match])
  })
  return found
}

export const findErrors = (obj, field, index) => {
  let count = 0
  for (const key in obj) {
    if (key.startsWith(`${field}.${index}`)) {
      count++
    }
  }
  return count
}
